export default "__VITE_ASSET__CNPNF0nc__"